import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import moment from 'moment';
import { PanelService } from 'app/shared/panels/chart/Services/panel.service';
import { IDropdown } from 'app/shared/interfaces/model';
import { IRangeForm, IRealTimeTags } from '../chart/Models/chart-settings.model';
import { ERanges } from './../../enums/common.enum';

@Component({
  selector: 'range-model',
  templateUrl: './range-model.component.html',
  styleUrls: ['./range-model.component.scss']
})

export class RangeModelComponent implements OnInit {
  startDate: any;
  endDate: any;
  toDate: string = '';
  fromDate: string = '';
  isFormValid: boolean = false;
  disabled: boolean = false;
  touchUi: boolean = false;
  ranges: IDropdown[] = [{ name: 'Last 1H', value: ERanges.H1 }, { name: 'Last 6H', value: ERanges.H6 }, { name: 'Last 12H', value: ERanges.H12 }, { name: 'Last 1D', value: ERanges.D1 }, { name: 'Last 1W', value: ERanges.W1 }, { name: 'Last 1M', value: ERanges.M1 }, { name: 'Last 3M', value: ERanges.M3 }];
  // dateTimePicker
  date: Date;
  showSpinners = true;
  showSeconds = false;
  enableMeridian = false;
  minDateFrom: Date;
  maxDateFrom: Date;
  minDateTo: Date;
  maxDateTo: Date;
  stepHour = 1;
  stepMinute = 1;
  stepSecond = 1;
  color: ThemePalette = 'primary';
  rangeForm: FormGroup = this.fb.group({
    range: '',
    fromDate: '',
    toDate: ''
  });

  constructor(private readonly panelService: PanelService, private readonly fb: FormBuilder, private dialogRef: MatDialogRef<RangeModelComponent>, @Inject(MAT_DIALOG_DATA)
  public incomingModelData: IRangeForm) {
    // stop closing model on out region click
    dialogRef.disableClose = true;
    console.log('incomingModelData: ', incomingModelData);
    console.log('defaultRangeData: rangeModel', incomingModelData);
    if (incomingModelData?.fromDate && incomingModelData.toDate) {
      this.rangeForm.patchValue({ range: (incomingModelData.isFirstCall) ? ERanges.D1 : incomingModelData.range, fromDate: incomingModelData.fromDate, toDate: incomingModelData.toDate });
      this.startDate = new Date(incomingModelData.fromDate).toLocaleString().replace(/,/g, '');
      this.endDate = new Date(incomingModelData.toDate).toLocaleString().replace(/,/g, '');
      this.isFormValid = (this.startDate && this.endDate) ? true : false;
    }

    this.maxDateFrom = new Date(Date.now());
    this.maxDateTo = new Date(Date.now());
  }

  ngOnInit() { }

  submit() {
    const objRangeForm: IRangeForm = { range: this.rangeForm.value?.range ? this.rangeForm.value?.range : null, fromDate: this.rangeForm.value?.fromDate ? moment(this.rangeForm.value?.fromDate).toDate() : moment(this.startDate).toDate(), toDate: this.rangeForm.value?.toDate ? moment(this.rangeForm.value?.toDate).toDate() : moment(this.endDate).toDate() }
    this.dialogRef.close(objRangeForm);
  }

  onToDateChange(value) {
    console.log('value: ', value);
    if (value) {
      this.rangeForm.patchValue({ range: null });
      this.toDate = value;
      this.onDateTimeChange(undefined, false, value);
    }
  }

  onDateTimeChange(value, isFromChanged?: boolean, toDate?: any) {
    console.log('this.endDate: ', toDate);
    console.log('value: Input ', value);
    if (value) {
      this.rangeForm.patchValue({ range: null });
      this.fromDate = value;
    }

    this.startDate = this.rangeForm.value?.fromDate ? new Date(this.rangeForm.value?.fromDate).toLocaleString().replace(/,/g, '') : '';
    this.endDate = this.rangeForm.value?.toDate ? new Date(this.rangeForm.value?.toDate).toLocaleString().replace(/,/g, '') : '';
    console.log('this.endDate:1 ', this.endDate);
    if (!this.startDate) {
      const fromDate = Date.parse(this.fromDate)
      this.startDate = new Date(fromDate)
    }

    if (!this.endDate) {
      const endDate = Date.parse(toDate);
      this.endDate = new Date(endDate);
      console.log('this.endDate:2 ', this.endDate);
    }

    this.isFormValid = ((this.startDate && this.endDate) || this.rangeForm.value.range) ? true : false;
  }

  onRangeChange(selectedRange: ERanges) {
    this.isFormValid = (this.rangeForm.value?.range) ? true : false;
    this.getStartDate(selectedRange);
    this.minDateTo = new Date(this.rangeForm.value?.fromDate);
  }

  getStartDate(range: ERanges) {
    const currentDateTime: number = Date.now();
    this.endDate = new Date(currentDateTime).toLocaleString().replace(/,/g, '');
    switch (range) {
      case ERanges.H1: {
        this.startDate = new Date(currentDateTime - 3600000).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - 3600000), toDate: new Date(currentDateTime) });
        break;
      }
      case ERanges.H6: {
        this.startDate = new Date(currentDateTime - 21600000).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - 21600000), toDate: new Date(currentDateTime) });
        break;
      }
      case ERanges.H12: {
        this.startDate = new Date(currentDateTime - 43200000).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - 43200000), toDate: new Date(currentDateTime) });
        break;
      }
      case ERanges.D1: {
        this.startDate = new Date(currentDateTime - 86400000).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - 86400000), toDate: new Date(currentDateTime) });
        break;
      }
      case ERanges.W1: {
        this.startDate = new Date(currentDateTime - (86400000 * 7)).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - (86400000 * 7)), toDate: new Date(currentDateTime) });
        console.log('this.rangeForm.value: ', this.rangeForm.value);
        break;
      }
      case ERanges.M1: {
        this.startDate = new Date(currentDateTime - (86400000 * 30)).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - (86400000 * 30)), toDate: new Date(currentDateTime) });
        break;
      }
      case ERanges.M3: {
        this.startDate = new Date(currentDateTime - (86400000 * 90)).toLocaleString().replace(/,/g, '');
        this.rangeForm.patchValue({ fromDate: new Date(currentDateTime - (86400000 * 90)), toDate: new Date(currentDateTime) });
        break;
      }
      default: {
        console.log("!Invalid Range");
        break;
      }
    }
  }


}
